<template>
        <!-- <div id="preloader">
            <div class="spinner">
                <div class="uil-ripple-css">
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div> -->
        <header :dir="$i18n.locale === 'en' ? 'ltr' : 'rtl'" class="site-header fixed-top">
            <div class="container-fluid">
                <div class="row justify-content-between">
                    <div class="col-xl-1 col-lg-1 my-auto d-none d-lg-block">
                        <div class="d-flex">
                            <a href="#" class="sidebar-toggle">
                                <i class="far fa-bars"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-2 my-auto d-none d-lg-block" style="margin-right: -15px;padding-right: 0;">
                        <div class="d-flex">
                            <div class="logo my-auto">
                                <router-link to="/"  class="custom-logo-link"><img src="../../assets/images/CR_logo.png" class="custom-logo" alt="كورساتك"></router-link> </div>
                        </div>
                    </div>
                    <div class="col-xl-7 col-lg-7 my-auto d-none d-xl-block">
                        <form class="ajax-search-form" @submit.prevent="SearchData()">
                            <input type="text" v-model="search" class="keyword" :placeholder="$t('nav.search')">
                            <button type="submit"><i class="fa fa-search"></i></button>
                            <ul class="datafetch"></ul>
                        </form>
                    </div>
                    <div class="col-xl-2 col-lg-2 my-auto" >
                        <div class="d-flex">
                            <div class="d-flex">
                                <div class="top-header-action">
                                    <div class="widget-header">
                                        <div class="col-12 my-auto">
                                            <div class="row">
                                                <div class="col-6" v-if="showHeader">
                                                    <label class="toggle-switch pointer"   >
                                                    <router-link to="/Unsubscribe" class="viewtube-btn  bordered" style="display: inline-block;text-align: center;font-size: 12px;" tabindex="0" savefrom_lm_index="0">{{ $t('nav.cancelSubscription') }}</router-link>
                                                    </label>
                                                </div>
                                                <div class="col-6" v-else>
                                                    <label class="toggle-switch pointer" >
                                                    <a @click="gotoSpay()" class="viewtube-btn  bordered" style="display: inline-block" tabindex="0" savefrom_lm_index="0">{{ $t('nav.subscribe') }}</a>

                                                    </label>
                                                </div>
                                                <div class="col-6" v-if="showHeader">
                                                    <label class="toggle-switch pointer"  >
                                                    <a @click="onLogout()" class="viewtube-btn  bordered" style="display: inline-block;text-align: center;font-size: 12px;" tabindex="0">{{ $t('nav.logout') }}</a>
                                                    </label>
                                                </div>
                                                <div class="col-6" v-else>
                                                    <label class="toggle-switch pointer" >
                                                    <router-link to="/login" class="viewtube-btn  bordered" style="display: inline-block" tabindex="0" >{{ $t('nav.login') }}</router-link>

                                                    </label>
                                                </div>

                                            </div>
                                        </div>
                                        
                                        <!-- <div class="my-account-widget">
                                            <div class="my-account-button">
                                                <i class="fad fa-user"></i>
                                            </div>
                                            <div class="my-account-content" dir="rtl">
                                                <div class="header-profile-login">
                                                    <h6 class="text-center">تسجيل الدخول الي حسابك</h6>
                                                    <form name="loginform" id="loginform" action="#" method="post">
                                                        <p class="login-username">
                                                            <label for="user_login">رقم الهاتف</label>
                                                            <input type="text" name="log" id="user_login" class="input" size="14" placeholder="2491XXXXXXXX" />
                                                        </p>
                                                        
                                                        <p class="login-submit">
                                                            <input type="submit" style="width: 100%;" name="wp-submit" id="wp-submit" class="button button-primary" value="تسجيل دخول" />
                                                        </p>
                                                    </form>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div class="off-canvas-menu-bar">
            <div class="pl-30 pr-30">
                <div class="row">
                    <div class="col-6 my-auto">
                        <div class="mobile-auth-row" v-if="showHeader">
                            <router-link to="/Unsubscribe" class="mobile-unsub-btn">{{ $t('nav.cancelSubscription') }}</router-link>
                        </div>
                        <div class="mobile-auth-row" v-else>
                            <a @click="gotoSpay()" class="mobile-auth-btn mobile-auth-btn--primary">{{ $t('nav.subscribe') }}</a>
                            <router-link to="/login" class="mobile-auth-btn mobile-auth-btn--outline">{{ $t('nav.login') }}</router-link>
                        </div>
                    </div>
                    <div class="col-4 my-auto mobile-logo-cell">
                        <router-link to="/" class="custom-logo-link" rel="home" aria-current="page"><img src="../../assets/images/CR_logo.png" class="custom-logo mobile-logo-img" alt="كورساتك"></router-link>
                    </div>
                    <div class="col-2 my-auto">
                        <div class="mobile-nav-toggler" ><span class="fas fa-bars" ></span></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 " style="margin-top: 10px;padding-right: 0;padding-left: 0;">
                        <div class="col-xl-7 col-lg-7 my-auto  d-xl-block" style="padding-right: 0;padding-left: 0;">
                        <form class="ajax-search-form" @submit.prevent="SearchData()">
                            <input type="text" v-model="search" class="keyword" :placeholder="$t('nav.search')">
                            <button type="submit"><i class="fa fa-search"></i></button>
                            <ul class="datafetch"></ul>
                        </form>
                    </div>
                    </div>
                    
                        
                </div>
            </div>
        </div>
        <div class="off-canvas-menu">
            <div class="menu-backdrop"></div>
            <i class="close-btn fa fa-close"></i>
            <nav class="mobile-nav">
                <div class="text-center pt-3 pb-3">
                    <router-link to="/" class="custom-logo-link" rel="home"><img src="../../assets/images/CR_logo.png" class="custom-logo" alt="Sayara"></router-link>
                </div>
                <ul class="navigation menu">
                    <li class="menu-item current-menu-item">
                        <router-link to="/" @click="closeMobileMenu">
                            <i class="fas fa-home"></i><span>{{ $t('nav.home') }}</span>
                        </router-link>
                    </li>
                    <li class="menu-item">
                        <router-link to="/Courses" @click="closeMobileMenu">
                            <i class="fas fa-coffee"></i><span>{{ $t('nav.courses') }}</span>
                        </router-link>
                    </li>
                    <li class="menu-item">
                        <router-link to="/Teachers" @click="closeMobileMenu">
                            <i class="fa fa-user"></i><span>{{ $t('nav.teachers') }}</span>
                        </router-link>
                    </li>
                    <li class="menu-item pointer" v-if="showHeader">
                        <router-link to="/Unsubscribe" @click="closeMobileMenu">
                            <i class="fas fa-tag"></i><span>{{ $t('nav.unsubscribe') }}</span>
                        </router-link>
                    </li>
                    <li class="menu-item pointer" v-if="showHeader">
                        <a @click="onLogout">
                            <i class="fas fa-sign-out-alt"></i><span>{{ $t('nav.logout') }}</span>
                        </a>
                    </li>
                    <li class="menu-item pointer" v-else>
                        <a @click="gotoSpay">
                            <i class="fas fa-tag"></i><span>{{ $t('nav.subscribe') }}</span>
                        </a>
                    </li>
                    <li class="menu-item pointer">
                        <a @click="onToggleLocale">
                            <i class="fas fa-globe"></i><span>{{ $t('langToggle') }}</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
</template>

<script>
import { HTTP } from '@/Api/http-common';
import { ref } from '@vue/reactivity';
import { useRoute, useRouter } from 'vue-router';
import { watchEffect } from '@vue/runtime-core';
import { useCookie } from 'vue-cookie-next'
import { toggleLocale } from '@/i18n';
import { logout } from '@/session';
export default {
   name: 'AppHeader',
   data() {
     return {
        
     }
    },
    
    mounted() {
       let externalScript = document.createElement("script");
       externalScript.setAttribute("src", "/static/js/main.js");
       document.head.appendChild(externalScript);

       let externalScript2 = document.createElement("script");
       externalScript2.setAttribute("src", "/static/js/search.js");
       document.head.appendChild(externalScript2);
    },
    setup() {
        const router = useRouter();
        const route = useRoute();
        const search = ref([]);
        const SearchData = () => {
            router.push({ name: "Searchs", params: { search_id: search.value } });
        }
        const cookie = useCookie()
        const showHeader = ref(true);
        watchEffect(() => {
            if (cookie.isCookieAvailable("status") && cookie.isCookieAvailable("msisdn")) {
                HTTP.post(`CheckLogin.php?username=`+cookie.getCookie("msisdn")+ `&serviceId=2222&operatorID=2`).then((res) => {
                    if (res.data.status === 1 ) {
                        return;
                    } else {
                        cookie.removeCookie("remming_minutes");
                        cookie.removeCookie("msisdn");
                        cookie.removeCookie("status");
                    }
                });
                showHeader.value = true;
            } else {
               showHeader.value = false;
            }
        });  
        // return {  };
        return { showHeader,search, SearchData };
    },
    methods: {
      gotoSpay() {
        window.open("https://digital.sudanipay.com/subscription/courseatk/courseatk", "_self");
        this.closeMobileMenu();
      },
      onToggleLocale() {
        toggleLocale();
        this.closeMobileMenu();
      },
      onLogout() {
        this.closeMobileMenu();
        logout(this.$cookie);
      },
      closeMobileMenu() {
        if (typeof document !== 'undefined') {
          document.body.classList.remove('off-canvas-menu-visible');
        }
      },
  }
}
</script>

<style>
.pointer {
  cursor: pointer;
}

/* Subscribe + Login row on mobile */
.mobile-auth-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}
.mobile-auth-btn {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 7px 12px;
  border-radius: 18px;
  text-align: center;
  text-decoration: none;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #0000c8;
  transition: background 0.2s, transform 0.1s;
}
.mobile-auth-btn--primary {
  background: #0000c8;
  color: #fff !important;
}
.mobile-auth-btn--primary:hover { background: #0000a0; color: #fff !important; }
.mobile-auth-btn--outline {
  background: transparent;
  color: #0000c8 !important;
}
.mobile-auth-btn--outline:hover { background: #0000c8; color: #fff !important; }

/* Clean filled mobile unsubscribe button */
.mobile-unsub-btn {
  display: inline-block;
  background: #0000c8;
  color: #fff !important;
  font-size: 12px;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 22px;
  text-align: center;
  text-decoration: none;
  line-height: 1;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 200, 0.25);
  transition: background 0.2s, transform 0.1s;
}
.mobile-unsub-btn:hover,
.mobile-unsub-btn:focus {
  background: #0000a0;
  color: #fff !important;
}
.mobile-unsub-btn:active {
  transform: translateY(1px);
}

/* Crisp logo on high-DPI screens */
.custom-logo {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

/* Mobile logo: constrain size + center in its column so it doesn't bump the hamburger */
.mobile-logo-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 6px;
}
.mobile-logo-img {
  max-width: 100%;
  max-height: 36px;
  width: auto;
  height: auto;
  display: block;
}

/* Sharpen hamburger icon (was getting blurred by some inherited transform) */
.mobile-nav-toggler {
  font-size: 22px;
  color: #005C93;
  cursor: pointer;
  line-height: 1;
}
.mobile-nav-toggler .fas {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>